import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ClassificationResponse } from 'src/app/models/classification-response.model'

@Injectable({
  providedIn: 'root',
})
export class ClassificationService {
  public static readonly classificationEndpoint = '/classification'

  constructor(private readonly http: HttpClient) {}

  getClassification(
    fundId: string,
    isInternal: boolean,
    isBfpClassificationToggle: boolean,
  ): Observable<ClassificationResponse> {
    const params = new HttpParams()
      .set('isInternal', String(isInternal))
      .set('isBfpClassificationToggle', String(isBfpClassificationToggle))
    return this.http.get<ClassificationResponse>(
      `vmf/api/${fundId}`.concat(ClassificationService.classificationEndpoint),
      { params },
    )
  }
}
